export function getToken() {
 
  var loginUser=JSON.parse(localStorage.getItem("LoginUser"));
  if(loginUser==null) return '';
  return loginUser.token;
}
